import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'

import CoachView from './coach-view'
import ConsumerView from './consumer-view'

import StepDescription from '../step-description'
import CoachAddStudentModal from 'components/add-student-modal/coach-add-student-modal'
import ConsumerAddStudentModal from 'components/add-student-modal/consumer-add-student-modal'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined'

export default ({ students, currentUrl, previousUrl, isCoach, user }) => {
  const [openAddStudent, setOpenAddStudent] = useState(false)
  const history = useHistory()

  return (
    <>
      <Grid item xs={12}>
        <Box flexGrow={1} display={{ xs: 'none', md: 'flex' }}>
          <Button href={previousUrl} startIcon={<ArrowBackOutlinedIcon />}>
            BACK
          </Button>
        </Box>
      </Grid>
      <Grid container spacing={2}>
        <StepDescription
          stepText="Step 2 of 3"
          title="Student"
          description={
            isCoach
              ? 'Select a student to attend this session.'
              : 'Who will be attending this session?'
          }
        />
      </Grid>
      {isCoach ? (
        <>
          <CoachView
            searchableItems={students}
            history={history}
            currentUrl={currentUrl}
            openAddStudent={openAddStudent}
            setOpenAddStudent={setOpenAddStudent}
          />
          <CoachAddStudentModal
            open={openAddStudent}
            setOpen={setOpenAddStudent}
            onAdd={data => {
              const newStudentId = data?.createStudent?.student?.id
              history.push(`${currentUrl}&studentId=${newStudentId}`)
            }}
            dialogTitle="Add New Student"
            btnTitle="Add Student"
          />
        </>
      ) : (
        <>
          <ConsumerView
            students={students}
            history={history}
            currentUrl={currentUrl}
            openAddStudent={openAddStudent}
            setOpenAddStudent={setOpenAddStudent}
            user={user}
          />
          <ConsumerAddStudentModal
            open={openAddStudent}
            setOpen={setOpenAddStudent}
            onAdd={data => {
              const newStudentId = data?.createStudent?.student?.id
              history.push(`${currentUrl}&studentId=${newStudentId}`)
            }}
            dialogTitle="Add New Student"
            btnTitle="Add Student"
          />
        </>
      )}
    </>
  )
}
